import {makeAutoObservable, runInAction} from "mobx";
import CreateRmaService, {IPlatformProduct} from "../../../services/api/create-rma-service";
import {rootContainer, TYPE} from "../../../services/container/root";
import PlatformProductSearchStore from "./platform-product-search-store";
import PlatformVariantStore from "./platform-variant-store";



class PlatformProductStore {
    private _model: IPlatformProduct;
    private _variants: PlatformVariantStore[] = [];
    private _selectedVariant?: PlatformVariantStore;
    private _isLoading: boolean = false;
    
    constructor(model: IPlatformProduct, private _platformProductSearchStore : PlatformProductSearchStore) {
        makeAutoObservable(this, {}, {autoBind: true});
        this._model = model;
    }
    
    public get isLoading() : boolean { return this._isLoading; }
    public get variants(): PlatformVariantStore[] { return this._variants; }
    
    private get _service(): CreateRmaService { return rootContainer.get<CreateRmaService>(TYPE.CreateRmaService); }
    
    public async loadVariants(){
        this._isLoading = true;
        try{
            const variants = await this._service.getVariants(this._model.id, this._platformProductSearchStore.selectedlocationId);
            runInAction(() => {
                this._isLoading = false;
                this._variants = variants.map((variant) => new PlatformVariantStore(variant));
            
            });
        }
        catch (e) {
            runInAction(() => {
                this._isLoading = false;
            });
        }
    }
    
    public get id() : number { return this._model.id; }
    public get title() : string { return this._model.title; }
    public get imageSrc() : string { return this._model.image_src; }
    public get selectedVariant() : PlatformVariantStore | undefined { return this._selectedVariant; }
    public get noVariants() : boolean { return this._model.has_only_default_variant; }
    
    public selectVariant(variant: PlatformVariantStore) {
        this._selectedVariant = variant;
    }
    
}

export { PlatformProductStore as default };
